import { Link } from "react-router-dom";
import { User, LayoutDashboard, Package, LogOut } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { loginWithGoogle } from "@/lib/api";

export const UserMenu = () => {
  const { user, loading, logout } = useAuth();
  if (loading) return <span className="h-10 w-10" />;
  if (!user)
    return (
      <button data-testid="login-button" onClick={loginWithGoogle}
        className="flex items-center gap-2 rounded-full px-3 py-2 text-sm transition-colors hover:bg-[var(--bone-2)]">
        <User className="h-4 w-4" /><span className="hidden sm:inline">Connexion</span>
      </button>
    );
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger data-testid="user-menu-trigger" className="rounded-full outline-none ring-offset-2 focus-visible:ring-2 focus-visible:ring-[var(--terra)]">
        {user.picture
          ? <img src={user.picture} alt={user.name} className="h-10 w-10 rounded-full border border-[var(--line)] object-cover" referrerPolicy="no-referrer" />
          : <span className="grid h-10 w-10 place-items-center rounded-full bg-[var(--ink)] text-sm text-[var(--bone)]">{user.name?.[0]}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 bg-[var(--bone)]">
        <DropdownMenuLabel className="font-normal">
          <p className="text-sm font-medium">{user.name}</p>
          <p className="truncate text-xs text-[var(--muted)]">{user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.is_admin && (
          <DropdownMenuItem asChild><Link data-testid="menu-admin-link" to="/admin"><LayoutDashboard className="mr-2 h-4 w-4" />Tableau de bord</Link></DropdownMenuItem>
        )}
        <DropdownMenuItem asChild><Link data-testid="menu-orders-link" to="/compte"><Package className="mr-2 h-4 w-4" />Mes commandes</Link></DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="logout-button" onClick={logout}><LogOut className="mr-2 h-4 w-4" />Déconnexion</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
